module.exports = __webpack_public_path__ + "img/667.8f4cea2b.svg";